// tslint:disable
/**
 * respondeco.org
 * API description of respondeco.org
 *
 * The version of the OpenAPI document: 1.2.5
 * Contact: klaus@respondeco.org
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

      export interface CreateImageRequest {
        file?: Blob;
      }

      export interface GetImageRequest {
        imageId: string;
        size?: string;
        width?: number;
        height?: number;
        crop?: boolean;
      }


/**
* no description
*/
export interface ImagesApi {
    /**
      * Post an image
    */
    createImage(requestParameters: CreateImageRequest): Promise<string>
    /**
      * Get an image
    */
    getImage(requestParameters: GetImageRequest): Promise<Blob>
}

  /**
  * no description
  */
  export class ImagesApiImpl extends runtime.BaseAPI implements ImagesApi {

    /**
      * Post an image
    */
    async createImageRaw(requestParameters: CreateImageRequest): Promise<runtime.ApiResponse<string>> {
      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
        const formData = new FormData();
            if (requestParameters.file !== undefined) {
              formData.append('file', requestParameters.file as any);
            }
      const response = await this.request({
      path: `/images`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
        body: formData,
      });

              return new runtime.TextApiResponse(response);
      }

      /**
        * Post an image
      */
      async createImage(requestParameters: CreateImageRequest): Promise<string> {
        const response = await this.createImageRaw(requestParameters);
        return await response.value();
      }

    /**
      * Get an image
    */
    async getImageRaw(requestParameters: GetImageRequest): Promise<runtime.ApiResponse<Blob>> {
          if (requestParameters.imageId === null || requestParameters.imageId === undefined) {
          throw new runtime.RequiredError('imageId','Required parameter requestParameters.imageId was null or undefined when calling getImage.');
          }

      const queryParameters: runtime.HTTPQuery = {};

          if (requestParameters.size !== undefined) {
              queryParameters['size'] = requestParameters.size;
          }

          if (requestParameters.width !== undefined) {
              queryParameters['width'] = requestParameters.width;
          }

          if (requestParameters.height !== undefined) {
              queryParameters['height'] = requestParameters.height;
          }

          if (requestParameters.crop !== undefined) {
              queryParameters['crop'] = requestParameters.crop;
          }

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/images/{imageId}`.replace(`{${"imageId"}}`, encodeURIComponent(String(requestParameters.imageId))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

          return new runtime.BlobApiResponse(response);
      }

      /**
        * Get an image
      */
      async getImage(requestParameters: GetImageRequest): Promise<Blob> {
        const response = await this.getImageRaw(requestParameters);
        return await response.value();
      }

    }
